import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { whyUs } from "../lib/data";

export default function WhyChooseUs() {
  return (
    <section className="relative py-28 px-6 lg:px-8 bg-[#070B1A]">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16">
          <span className="section-label">Why Wealthoo</span>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tighter mt-5">
            Engineered for <span className="gradient-text">trust</span>, designed for growth
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-6 top-0 bottom-0 w-px bg-gradient-to-b from-blue-500/60 via-blue-500/30 to-transparent hidden md:block" />
          <div className="grid md:grid-cols-2 gap-6">
            {whyUs.map((w, i) => (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className="relative pl-16 group"
                data-testid={`why-item-${i}`}
              >
                <div className="absolute left-0 top-1 w-12 h-12 rounded-2xl glass-strong flex items-center justify-center border border-blue-500/30 group-hover:bg-blue-600/20 transition-colors">
                  <Check className="w-5 h-5 text-blue-400" strokeWidth={3} />
                </div>
                <h3 className="text-xl font-bold tracking-tight">{w.title}</h3>
                <p className="text-sm text-slate-400 mt-2">{w.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
